<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-ad-commission-agreement-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Ad Commission Agreement
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.commission"
                name="commission"
                label="Commission"
                :error="getError('commission')"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: { TextFormGroup},

  mixins: [Errors],

  props: {
    adCommissionAgreement: {
      required: true
    }
  },

  data() {
    return {
      data: {}
    }
  },

  watch: {
    adCommissionAgreement() {
      this.data = {...this.adCommissionAgreement.attributes}
    }
  },

  mounted() {
    this.listenForClose()
  },


  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/ad-commission-agreements/' + this.adCommissionAgreement.id, this.data)
          .then(response => {
            notify.success('The ad commission agreement was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}
    }
  }
}
</script>
